<div class="page-header-container">
  <md-page-header title="{{ 'LABELS.END_PRODUCTS' | translate }}" icon="product"></md-page-header>
</div>
